module.exports = {"331002001":"海门街道","331002002":"白云街道","331002003":"葭沚街道","331002004":"洪家街道","331002005":"三甲街道","331002006":"下陈街道","331002007":"前所街道","331002008":"章安街道","331002101":"大陈镇","331002400":"椒江农场","331002401":"滨海工业区","331002402":"月湖新城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331002.json
// module id = 937
// module chunks = 0